export default __webpack_public_path__ + "static/media/PrivacyPolicyPopUpy.9a6abf62.md";